export default {
  home: {
    message: "registration",
    bind_element: '[href*="sign-up"]',
    button_text: "register",
    action: {
      type: "target_click", //can also be 'target_click'
    },
  },
  "home-after-reg": {
    message: "auth",
    bind_element: '[href*="sign-in"]',
    button_text: "login",
    action: {
      type: "target_click",
    },
  },
  "home-after-login": {
    message: "find_a_partner",
    bind_element: '[href*="find-a-partner"]',
    button_text: "search_partner",
    action: {
      type: "target_click",
    },
  },
  "find-a-partner-index": {
    message: "find_a_partner_message",
    bind_element: "#init_search",
    button_text: "search_partner",
    action: {
      type: "target_click",
    },
  },
  "find-a-partner-result": {
    message: "find_a_partner_message_result",
    bind_element: "#check_aml",
    button_text: "check_partner",
    action: {
      type: "target_click",
    },
  },
  aml: {
    message: "next_create_contract",
    bind_element: '[href*="contracts"]',
    button_text: "create_contract",
    action: {
      type: "target_click",
    },
  },
  "contracts-index": {
    message: "to_create_contract_message",
    bind_element: "#add-new-contract___BV_tab_button__",
    button_text: "create_contract",
    action: {
      type: "target_click", //can also be 'go_to_route'
    },
  },
  "contracts-add": {
    message: "save_contract_message",
    bind_element: "#save-contract-button",
    button_text: "save_contract",
    action: {
      type: "target_click", //can also be 'go_to_route'
    },
  },
  "contracts-index-just-added": {
    message: "open_contract_message",
    bind_element: "#orders-table tbody tr:first-child",
    button_text: "open_contract",
    action: {
      type: "target_click", //can also be 'go_to_route'
    },
  },
  "contracts-single": {
    message: "sign_contract_message",
    bind_element: "#submit_and_sign_button",
    button_text: "sign_contract",
    action: {
      type: "target_click",
    },
  },
  "contracts-single-signed": {
    message: "contract_offers_message",
    bind_element: "#offers-tab___BV_tab_button__",
    button_text: "create_offer",
    action: {
      type: "target_click",
    },
  },
  "contracts-single-offers-tab": {
    message: "contract_couriers_message",
    bind_element: "#couriers-tab___BV_tab_button__",
    button_text: "create_offer",
    action: {
      type: "target_click",
    },
  },
  "contracts-single-couriers-tab": {
    message: "contract_brokers_message",
    bind_element: "#brokers-tab___BV_tab_button__",
    button_text: "create_offer",
    action: {
      type: "target_click",
    },
  },
  "contracts-single-brokers-tab": {
    message: "contract_docs_message",
    bind_element: "#docs-tab___BV_tab_button__",
    button_text: "create_documents",
    action: {
      type: "target_click",
    },
  },

  /**
   * Documents part, works with emits without router, just this.$root.$emit('trigger_navigation', 'route-name')
   */
  "pre-invoice": {
    message: "contract_docs_invoice_message",
    bind_element: "#add-document-button",
    button_text: "create_invoice",
    action: {
      type: "create_document",
      data: "invoice",
    },
  },
  "after-invoice": {
    message: "contract_docs_packing_list_message",
    bind_element: "#add-document-button",
    button_text: "create_packing_list",
    action: {
      type: "create_document",
      data: "packaging",
    },
  },
  "after-packaging": {
    message: "contract_docs_cmr_message",
    bind_element: "#add-document-button",
    button_text: "create_cmr",
    action: {
      type: "create_document",
      data: "cmr",
    },
  },
  "after-cmr": {
    message: "contract_docs_insurance_message",
    bind_element: "#add-document-button",
    button_text: "create_insurance",
    action: {
      type: "create_document",
      data: "insurance",
    },
  },
  "after-cmr-": {
    message: "contract_docs_liability_insurance_message",
    bind_element: "#add-document-button",
    button_text: "create_liability_insurance",
    action: {
      type: "create_document",
      data: "liability-insurance",
    },
  },
  "after-liability-insurance": {
    message: "contract_docs_exim_message",
    bind_element: "#exim-tab___BV_tab_button__",
    button_text: "create_exim_insurance",
    action: {
      type: "target_click",
    },
  },
};

/**
 * home: {
        message: 'registration',
        bind_element: '[href*="sign-up"]',
        action: {
            type: 'go_to_route', //can also be 'target_click'
            follow_route: {
                name: 'contracts-single',
                params: {'id': 102}
            },
        },
    },
 */
